module.exports = "<div class=\"grid-container\">\r\n    <table [id]=\"id\"></table>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./App/Components/grid.component.html
// module id = 552
// module chunks = 1